export enum TrainingPlanType {
  Course = 'Course',
  Curriculum = 'Curriculum',
}
